import { Pipe, PipeTransform } from '@angular/core';

import { DateTime } from 'luxon';

@Pipe({
    name: 'customDate',
    standalone: true
})

/**
 * Displays a 'Today' and 'Tomorrow label when relevant
 * @param {string} value - Value from the pipe
 * @param {string} format - Format of the datetime. Based on Luxon formatting
 * @param {boolean} displayAdditionalLabel - Displays a "Today" or "Tomorrow" label when relevant
 * @param {string} prependFormatValue - When the date is not "Today" or "Tomorrow", adds a formatted value before the 'format'
 */
export class CustomDatePipe implements PipeTransform {
    transform(
        value: string,
        format: string = 'MMM d, yyyy',
        displayAdditionalLabel: boolean = true,
        prependFormat: string = ''
    ): string {
        const adjustValue = value.replace(' ', 'T');
        const now = DateTime.now().set({ hour: 0, minute: 0, second: 0 });
        const nextDay = DateTime.now().set({ hour: 0, minute: 0, second: 0 }).plus({ days: 1 });
        const dateTimeObject = DateTime.fromISO(adjustValue);

        const prependFormatValue = prependFormat ? dateTimeObject.toFormat(prependFormat) + ' ' : '';

        if (displayAdditionalLabel && dateTimeObject.hasSame(now, 'day')) {
            return `Today ${dateTimeObject.toFormat(format)}`;
        } else if (displayAdditionalLabel && dateTimeObject.hasSame(nextDay, 'day')) {
            return `Tomorrow ${dateTimeObject.toFormat(format)}`;
        } else {
            return prependFormatValue + dateTimeObject.toFormat(format);
        }
    }
}
